import { validatePhone } from '../../../util/form-validation';

import { convertValidationRules } from '../../../hooks/useFormState';

export type Model = {
  receiveEmail: boolean;
  email: string;
  receiveText: boolean;
  textNumber: string;
  receiveCallBack: boolean;
  callbackPhoneNumber: string;
  encryptedEmailContactId?: string;
  encryptedTextNumberContactId?: string;
  encryptedEmailPreferenceId?: string | null | undefined;
  encryptedTextNumberPreferenceId?: string | null | undefined;
};

export default convertValidationRules<Model>(context => {
  const { receiveCallBack } = context.values;
  return {
    // this must match the names of the form fields
    callbackPhoneNumber: receiveCallBack ? validatePhone : null,
  };
});
